(function ($) {
	// Inquiry Form
	$(window).on('load', function () {
		$('select[name="Pref"]').each(function () {
			const selectedValue = $(this).val();
			if (selectedValue !== '' && selectedValue !== null) {
				$(this).closest('.dropdown-wrapper').addClass('selected');
				$(this).addClass('selected');
			}
		});
	});

	$('select[name="Pref"]').on('mousedown', function () {
		$(this).addClass('active');
	});

	$('select[name="Pref"]').on('focusout', function () {
		$(this).removeClass('active');
	});

	$('select[name="Pref"]').on('change', function () {
		const selectedValue = $(this).val();
		if (selectedValue !== '' && selectedValue !== null) {
			$(this).closest('.dropdown-wrapper').addClass('selected');
			$(this).addClass('selected');
		}
	});

	// Flow
	$('.flow__header').on('click', function () {
		$(this).toggleClass('active');
	});

	// Scroll To Target
	$('.js-scroll-to-target').on('click', function (e) {
		e.preventDefault();
		const currentPos = $(window).scrollTop();
		const target = $(this).attr('href');
		const targetPos = $(target).offset().top;
		const duration = Math.floor((targetPos - currentPos) / 4);

		$('html, body').animate(
			{
				scrollTop: targetPos
			},
			duration,
			'easeInOutQuart'
		);
	});

	// Video
	const presentVid = document.querySelector('.present-video > video');

	$('.present-video').on('click', function () {
		if (presentVid.paused) {
			$(this).addClass('playing');
			presentVid.play();
		} else {
			$(this).removeClass('playing');
			presentVid.pause();
		}
	});

	presentVid.addEventListener(
		'ended',
		function () {
			$('.present-video').removeClass('playing');
		},
		true
	);
})(jQuery);
